import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import OtpInput from "react-otp-input";
import { Formik, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import toast from "react-hot-toast";

const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .length(6, "OTP must be exactly 6 digits")
    .required("OTP is required"),
});

function EmailverifyModal({ show, handleClose, refresh ,updatedEmail }) {
  const [counter, setCounter] = useState(30); // 30 sec countdown
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest(`/profile/email-verification`, data);
    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
          primary: '#337FE0',
          secondary: '#FFFAEE',
        },
      })
      handleClose()
      refresh()
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  useEffect(() => {
    let timer;
    if (isResendDisabled && counter > 0) {
      timer = setInterval(() => {
        setCounter(prev => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled]);



  const { mutate: resendOtpFunc, } = useMutation({
    mutationFn: (data) => {
      return postRequest("/auth/resend", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        // window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleResendOTP = async () => {

    setIsResendDisabled(true);
    setCounter(30); // Reset timer

    const payload = {
      email:updatedEmail
    };
    resendOtpFunc(payload);
  };




  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>

          Verify OTP

        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="verify-otp">

          <h6>

            You will receive an OTP to confirm your updated email address.
          </h6>
        </div>
        <div className="account-created-pop">
          <Row>
            <Col lg={12} className="mx-auto">
              <Formik
                initialValues={{ otp: "" }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  console.log("Submitted values:", values);
                  const payload ={
                    otp:values?.otp
                }
                mutate(values);
                }}
              >
                {({ values, setFieldValue, handleSubmit }) => (
                  <FormikForm className="cmn-form-set" onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <div className="form-set set-otp mt-3">
                        <OtpInput
                          value={values.otp}
                          onChange={(val) => setFieldValue("otp", val)}
                          numInputs={6}
                          renderInput={(props) => <input {...props} />}
                        />
                      </div>
                      <ErrorMessage
                        name="otp"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                    <div className=" resend-otp d-flex justify-content-end">
                      <button type="button" onClick={() => handleResendOTP()}
                        disabled={isResendDisabled}>
                        {isResendDisabled ? `Resend in ${counter}s` : "Resend OTP"}
                      </button>
                    </div>
                    <div className="d-flex justify-content-end">
                      <Button variant="secondary" onClick={handleClose} className="me-2">
                        Cancel
                      </Button>
                      <Button type="submit" variant="primary">
                        Verify
                      </Button>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default EmailverifyModal;